import type { IContact } from "@bbj-types/contact";
import { Autocomplete, Stack, TextField } from "@mui/material";
import type React from "react";
import { ContactInfo } from "./contactInfo";
import { getContactOptionLabel } from "./logics";
import type { ContactPickerMode } from "./types";

interface IContactPickerSelectProps {
  mode: ContactPickerMode;
  contact: IContact | null;
  setContact: (value: IContact | null) => void;
  contacts?: IContact[];
  hidden?: boolean;
}

const renderContactOption = (props: React.HTMLAttributes<HTMLLIElement>, contact: IContact) => {
  return (
    <li {...props}>
      <ContactInfo contact={contact} />
    </li>
  );
};

export const ContactPickerSelect = ({
  mode,
  contact,
  setContact,
  contacts = [],
  hidden,
}: IContactPickerSelectProps) => {
  return (
    <Stack
      direction="column"
      sx={{
        display: hidden ? "none" : "unset",
      }}
    >
      <Autocomplete
        value={mode === "select" ? contact : null}
        onChange={(_, contact) => setContact(contact)}
        options={contacts}
        getOptionLabel={getContactOptionLabel}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        renderInput={(params) => <TextField {...params} label="Contacts" size="small" fullWidth />}
        renderOption={renderContactOption}
      />
    </Stack>
  );
};
